export const SortOptionsEnum = {
  ItemCode: 0,
  ItemDescription: 1,
};

export const FilterOptionsEnum = {
  AllItems: 0,
  LastPhysicalItem: 1,
  OnHandItems: 2,
  OrderAccessItems: 3,
};

export const GroupOptionsEnum = {
  None: 0,
  Vendor: 1,
  StorageLocation: 2,
  ItemGroup: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/PhysicalInventoryReportEnum.js